module.exports = __webpack_public_path__ + "static/media/dzip-logo-black.dcc19b8e.svg";